import React, { useEffect, useState } from 'react';
import AccordionHistory, {
  IFetchMoreRequest
} from './accordionHistory/accordionHistory';
import AccordionQuoteHistory from '@/main/components/shared/accordionQuoteHistory/accordionQuoteHistory';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import { procurementHistoricalapi } from '@/main/api';
import { ProcurementHistoricalRequest } from '@/main/models/request';
import { IDetailsHistoryProps } from './detailsHistory/detailsHistory';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import { getGuidScreenByRoute, getTranslateByKey } from '@/main/services/utils';
import { userIsBodyshop } from '@/main/services/utilsUser';
import * as S from './styles';
import { RoutesConstants } from '@/main/routes/routesConstants';

interface IModalHistoryProps {
  guidProcurement: string;
  guidQuote: string;
  isBuyer: boolean;
  showPrices: boolean;
  handleModalHistory: () => void;
}

function ModalHistory({
  guidProcurement,
  guidQuote,
  isBuyer,
  showPrices,
  handleModalHistory
}: IModalHistoryProps) {
  // States

  const [currentCollapse, setCurrentCollapse] = useState<string | false>(false);
  const hideQuoteHistory = !isBuyer && userIsBodyshop();

  // Core function
  const handleChangeCollapse = (panel: string) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean
  ) => {
    event.stopPropagation();
    event.preventDefault();
    setCurrentCollapse(isExpanded ? panel : false);
  };
  // Async function

  return (
    <S.Container>
      <AccordionHistory
        showPrices={showPrices}
        guidProcurement={guidProcurement}
        title={getTranslateByKey('information.order')}
        propsCollapse={{
          expanded: currentCollapse === 'panel1',
          onChange: handleChangeCollapse('panel1')
        }}
      />

      {!hideQuoteHistory && (
        <AccordionQuoteHistory
          isCollapse
          guidQuote={guidQuote}
          showPrices={showPrices}
          guidScreen={getGuidScreenByRoute(RoutesConstants.orderSearchOrder)}
          propsCollapse={{
            expanded: currentCollapse === 'panel2',
            onChange: handleChangeCollapse('panel2')
          }}
        />
      )}
      <SecondaryButton
        id="id-modalHistory-button-back"
        onClick={handleModalHistory}>
        {getTranslateByKey('information.back')}
      </SecondaryButton>
    </S.Container>
  );
}

export default ModalHistory;
